import { render, staticRenderFns } from "./helpForm.vue?vue&type=template&id=7bb580f8&scoped=true"
import script from "./helpForm.vue?vue&type=script&lang=js"
export * from "./helpForm.vue?vue&type=script&lang=js"
import style0 from "./helpForm.vue?vue&type=style&index=0&id=7bb580f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb580f8",
  null
  
)

export default component.exports